export default "/images/signup-bg.png?c2fd10907ddcac2d3f1ffcd9d9dc9b25";